import { FC } from "react";
import { useTranslation } from "react-i18next";
import { useDispatch, useSelector } from "react-redux";
import { TModalsState, setModalsData } from "../../../api/store/commonSlice";
import { AdminFormFieldSubmit } from "../../../components/admin/formFields";
import { EWidgetChartTypes } from "../types/overview.types";
import svgIcons from "../../../assets/svg/svgIcons";

type ModalSwitchChartTypeProps = {
  selectedChartType: EWidgetChartTypes;
  onChartTypeChange: (newChartType: EWidgetChartTypes) => void;
};

const ModalSwitchChartType: FC<ModalSwitchChartTypeProps> = ({
  selectedChartType,
  onChartTypeChange,
}) => {
  const { t: tMain } = useTranslation();
  const { t } = useTranslation("translation", {
    keyPrefix: "overviewScreen.switch_chart_type",
  });
  const modalsState = useSelector(
    (state: { commonReducer: { modals: TModalsState } }) =>
      state.commonReducer.modals
  );
  const dispatch = useDispatch();
  const hideModal = () => {
    dispatch(
      setModalsData({
        ...modalsState,
        switchChartTypeForWidget: null,
        switchChartTypeForCustomWidgetId: null,
        showSwitchChartType: false,
      })
    );
  };

  const handleChange = (newChartType: EWidgetChartTypes) => {
    onChartTypeChange(newChartType);
    setTimeout(() => hideModal(), 250);
  };

  if (modalsState.showSwitchChartType === false) return null;

  return (
    <>
      <div className="justify-center items-center flex overflow-x-hidden overflow-y-auto fixed inset-0 outline-none focus:outline-none z-modal">
        <div
          className="relative my-6 mx-auto max-w-[calc(100vw-4rem)] w-[480px]"
          onClick={hideModal}
        >
          <div
            className="fixed w-full h-screen top-0 left-0 bg-modal-overlay z-overlay"
            onClick={hideModal}
          ></div>
          <div
            className="p-8 bg-white grid grid-cols-6 gap-6 rounded-3xl shadow-2xl relative z-modal"
            onClick={(e) => e.stopPropagation()}
          >
            <h2 className="col-span-6 text-3xl font-bold text-heading-black">
              {t("heading")}
            </h2>

            <div className="col-span-6 flex flex-col gap-3">
              {Object.values(EWidgetChartTypes).map((chartType) => (
                <AdminFormFieldSubmit
                  key={chartType}
                  label={
                    <span className="flex items-center justify-start w-full">
                      <img
                        src={svgIcons[`ChartType${chartType}`]}
                        alt={chartType}
                        className={`size-6 mr-2 ${selectedChartType === chartType ? "group-focus:grayscale-0 group-focus:brightness-0 group-focus:invert group-hover:grayscale-0 group-hover:brightness-0 group-hover:invert" : ""}`}
                      />
                      {t(`types.${chartType}`)}
                    </span>
                  }
                  type="button"
                  variant={
                    selectedChartType === chartType ? "primary" : "primary-alt"
                  }
                  buttonDimensionClass={`h-11 w-full px-4${selectedChartType === chartType ? " pointer-events-none touch-none" : ""}`}
                  onClick={() => handleChange(chartType)}
                />
              ))}
            </div>

            <AdminFormFieldSubmit
              label={tMain("close")}
              type="button"
              variant="danger-transparent"
              onClick={hideModal}
            />
          </div>
        </div>
      </div>
    </>
  );
};

export default ModalSwitchChartType;
